export const validatePhoneNumber = (value, allowEmpty) => {
  return (
    (!value && allowEmpty) ||
    /^(\+?\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value)
  )
}

export const cleanUpSMSState = (smsState) => {
  if (
    ((smsState.receive_shipping_updates_by_sms ||
      smsState.receive_podcast_notifications_by_sms) &&
      !smsState.sms_number) ||
    (!smsState.receive_shipping_updates_by_sms &&
      !smsState.receive_podcast_notifications_by_sms &&
      smsState.sms_number)
  ) {
    smsState.receive_shipping_updates_by_sms = false
    smsState.receive_podcast_notifications_by_sms = false
  }
  if (
    smsState.shipping_method === null &&
    smsState.options.shipping_choices.length > 0
  ) {
    smsState.shipping_method = smsState.options.shipping_choices[0].value
  }
  return smsState
}
